import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import BrandedLoader from './BrandedLoader';
import { useSmartBrandedLoader } from './useSmartBrandedLoader';

type BrandedLoaderOverlayProps = {
  active: boolean;
  scope?: 'fixed' | 'local';
  className?: string;
  /** When true, show on first paint without delay (page entry). */
  immediate?: boolean;
};

/** Branded logo + spinner with smart delay and fade (shared account/action loading). */
function BrandedLoaderOverlay({
  active,
  scope = 'fixed',
  className = '',
  immediate = false,
}: BrandedLoaderOverlayProps) {
  const show = useSmartBrandedLoader(active, immediate);
  const loader = <BrandedLoader show={show} scope={scope} className={className} />;

  if (scope === 'fixed' && typeof document !== 'undefined') {
    return createPortal(loader, document.body);
  }

  return loader;
}

export default memo(BrandedLoaderOverlay);
